// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Medias-MediaItem-___MediaItem-module__media {
  position: relative;
  margin-bottom: 10px;
  border-radius: 8px;
}
  .app-components-Medias-MediaItem-___MediaItem-module__media:hover .app-components-Medias-MediaItem-___MediaItem-module__pinnedIconContainer {
      opacity: 0;
    }

.app-components-Medias-MediaItem-___MediaItem-module__media:not(:last-child) {
  margin-right: 20px;
}

.app-components-Medias-MediaItem-___MediaItem-module__pinnedIconContainer {
  opacity: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: absolute;
  top: 0;
  left: 0;
  margin: 10px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 4px;
  z-index: 1;
}

.app-components-Medias-MediaItem-___MediaItem-module__pinnedIcon {
  color: #3dc3d2;
}

.app-components-Medias-MediaItem-___MediaItem-module__pinnedIcon > div {
    margin: 5px;
    font-size: 19px;
  }

.app-components-Medias-MediaItem-___MediaItem-module__imageContainer {
  padding: 0 2px;
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.5);
  margin-bottom: 5px;
}

.app-components-Medias-MediaItem-___MediaItem-module__image {
  max-width: 100%;
  position: relative;
  bottom: -2px;
}

.app-components-Medias-MediaItem-___MediaItem-module__other {
  width: 150px;
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: flex-start;
  text-align: center;
  box-sizing: border-box;
}

.app-components-Medias-MediaItem-___MediaItem-module__removeMedia {
  position: absolute;
  right: 5px;
  top: 5px;
  color: #ffffff;
  padding: 4px 6px;
  display: flex;
  cursor: pointer;
}

.app-components-Medias-MediaItem-___MediaItem-module__removeMedia:hover {
  border-color: var(--colors-black);
}
`, "",{"version":3,"sources":["webpack://./app/components/Medias/MediaItem/MediaItem.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AAMpB;EAJI;MACE,UAAU;IACZ;;AAIJ;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAKhB;;AAJE;IACE,WAAW;IACX,eAAe;EACjB;;AAGF;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".media {\n  position: relative;\n  margin-bottom: 10px;\n  border-radius: 8px;\n  &:hover {\n    .pinnedIconContainer {\n      opacity: 0;\n    }\n  }\n}\n\n.media:not(:last-child) {\n  margin-right: 20px;\n}\n\n.pinnedIconContainer {\n  opacity: 1;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin: 10px;\n  background-color: rgba(255, 255, 255, 0.7);\n  border-radius: 4px;\n  z-index: 1;\n}\n\n.pinnedIcon {\n  color: #3dc3d2;\n  & > div {\n    margin: 5px;\n    font-size: 19px;\n  }\n}\n\n.imageContainer {\n  padding: 0 2px;\n  border-radius: 2px;\n  background-color: #ffffff;\n  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.5);\n  margin-bottom: 5px;\n}\n\n.image {\n  max-width: 100%;\n  position: relative;\n  bottom: -2px;\n}\n\n.other {\n  width: 150px;\n  display: flex;\n  padding: 10px;\n  flex-direction: column;\n  align-items: center;\n  align-content: center;\n  justify-content: flex-start;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.removeMedia {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  color: #ffffff;\n  padding: 4px 6px;\n  display: flex;\n  cursor: pointer;\n}\n\n.removeMedia:hover {\n  border-color: var(--colors-black);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"media": `app-components-Medias-MediaItem-___MediaItem-module__media`,
	"pinnedIconContainer": `app-components-Medias-MediaItem-___MediaItem-module__pinnedIconContainer`,
	"pinnedIcon": `app-components-Medias-MediaItem-___MediaItem-module__pinnedIcon`,
	"imageContainer": `app-components-Medias-MediaItem-___MediaItem-module__imageContainer`,
	"image": `app-components-Medias-MediaItem-___MediaItem-module__image`,
	"other": `app-components-Medias-MediaItem-___MediaItem-module__other`,
	"removeMedia": `app-components-Medias-MediaItem-___MediaItem-module__removeMedia`
};
export default ___CSS_LOADER_EXPORT___;
